import { dtsAPI } from "../../axios";

export const actions = {

    // Process Type
    GetProcessType(context, data){
        return dtsAPI.get(`ProcessType/All`);
    },
    GetSingleProcessType(context, data){
        return dtsAPI.get(`ProcessType/${data}`);
    },
    GetProcessTypeChild(context, data){
        return dtsAPI.get(`ProcessType/Child/${data}`);
    },
    GetProcessTypeParent(context, data){
        return dtsAPI.get(`ProcessType/Parent/${data}`);
    },
    GetMyProcessType(context, data){
        return dtsAPI.get(`ProcessType/My/AddedProcessTypes/${data}`);
    },
    UpdateProcessType(context, data){
        return dtsAPI.put(`ProcessType/${data.id}`, data);
    },
    DeleteProcessType(context, data){
        return dtsAPI.delete(`ProcessType/${data}`);
    },
    CreateProcessType(context, data){
        return dtsAPI.post(`ProcessType/${data.officeId}`, data);
    },

    // Process Type Delivery Unit
    GetDUByProcessType(context, data){
        return dtsAPI.get(`ProcessTypeDeliveryUnit/All/${data}`);
    },
    GetProcessTypeByDU(context, data){
        return dtsAPI.get(`ProcessTypeDeliveryUnit/ProcessTypes/${data}`);
    },
    RemoveProcessTypeDU(context, data){
        return dtsAPI.delete(`ProcessTypeDeliveryUnit/Remove/${data.processTypeId}/${data.deliveryUnitId}`);
    },
    AddProcessTypeDU(context, data){
        return dtsAPI.post(`ProcessTypeDeliveryUnit/Add/${data.id}`, data.array);
    },

}